import * as React from "react";

function CloseXIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "nonzero",
    points: "8.707 7.952 13.328 12.573 12.621 13.28 8 8.659 3.37899997 13.28 2.67199997 12.573 7.293 7.952 2.67199997 3.33099997 3.37899997 2.62399997 8 7.245 12.621 2.62399997 13.328 3.33099997"
  }));
}

export default CloseXIcon;